import React, { useState, useEffect} from 'react'
import styles from './Invoice.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { toCommas } from '../../utils/utils'
import { useSnackbar } from 'react-simple-snackbar'
import IconButton from '@material-ui/core/IconButton';
import DeleteOutlineRoundedIcon from '@material-ui/icons/DeleteOutlineRounded';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import InputBase from '@material-ui/core/InputBase';
import { Container, Grid } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import SaveIcon from '@material-ui/icons/Save';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import {initialStateInvoice} from '../../initialState'
import currencies from '../../currencies.json'
import { createInvoice, getInvoice, updateInvoice } from '../../actions/invoiceActions';
import { getClientsByUser } from '../../actions/clientActions'
import AddClient from './AddClient';
import InvoiceType from './InvoiceType';
import axios from 'axios'
import { getMetalsByUser } from '../../actions/metalActions'
import { getAllShippings } from '../../actions/shippingActions'
import { useLocation  } from 'react-router-dom'
import { Notes } from '@material-ui/icons'
import { subtract } from 'lodash'
import { sub } from 'date-fns'

const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    large: {
      width: theme.spacing(12),
      height: theme.spacing(12),
    },
    table: {
        minWidth: 650,
      },

    headerContainer: {
        // display: 'flex'
        paddingTop: theme.spacing(1),
        paddingLeft: theme.spacing(5),
        paddingRight: theme.spacing(1),
    }
  }));

const Invoice = () => {
    const location = useLocation()
    const [invoiceData, setInvoiceData] = useState(initialStateInvoice)
    const [ rates, setRates] = useState(0)
    const [vat, setVat] = useState(0)
    const [currency, setCurrency] = useState("USD")
    const [subTotal, setSubTotal] = useState(0)
    const [stockPrice, setStockPrice] = useState(0)
    const [total, setTotal] = useState(0)
    const today = new Date();
    const [selectedDate, setSelectedDate] = useState(moment().format('MM/DD/YYYY'));
    const [ client, setClient] = useState(null)
    const [type, setType] = useState('Invoice')
    const [notes, setNotes] = useState('')
    const [invoiceNumber, setInvoiceNumber] = useState('')
    const [shippingMethod, setShippingMethod] = useState('')
    const [shippingCharges, setShippingCharges] = useState(0)
    const { id } = useParams()
    const clients = useSelector((state) => state.clients.clients)
    const { invoice } = useSelector((state) => state.invoices);
    const metals = useSelector((state) => state.metals.metals)
    const shippings = useSelector((state) => state.shipping.shippings)
    const [status, setStatus] = useState('Unpaid')
    const dispatch = useDispatch()
    const history = useHistory()
    const user = JSON.parse(localStorage.getItem('profile'))
    const [openSnackbar, closeSnackbar] = useSnackbar()


    useEffect(() => {
        if (id==undefined)
             getTotalCount()
         // eslint-disable-next-line
    },[location])


    const getTotalCount = async() => {
        try {
            const response = await axios.get(`${global.config.API_URL}/invoice/nextInvoiceNumber`);
            //   console.log(response.data);
            //Get total count of invoice from the server and increment by one to serialized numbering of invoice
            setInvoiceNumber('YT'+(Number(response.data.count) + 1).toString().padStart(5, '0'))
        } catch (error) {
          console.error(error);
        }
      }
      



    useEffect(() => {
        dispatch(getInvoice(id));
        // eslint-disable-next-line
      }, [id]);

    useEffect(() => {
        dispatch(getMetalsByUser({search: ''}));
        dispatch(getClientsByUser(""));
        dispatch(getAllShippings());
        // eslint-disable-next-line
    }, [dispatch]);


    useEffect(() => {
        if(invoice) {
            //Automatically set the default invoice values as the ones in the invoice to be updated

           
            //console.log('invoice',invoice)
            setInvoiceData(invoice)
            setInvoiceNumber(invoice.invoiceNumber);
            setClient(invoice.customer[0])            
            setStockPrice(invoice.stockPrice)
            setSelectedDate(invoice.invoiceDate)
            setRates(invoice.taxRate) 
            setNotes(invoice.notes) 
            setShippingCharges(invoice.shippingCharges) 
            setShippingMethod(invoice.shippingMethod)
            setNotes(invoice.notes) 
            setInvoiceData({...invoiceData, items: invoice.items}) 
        }
    }, [invoice])

 
    useEffect(() => {
        if(type === 'Receipt') {
            setStatus('Paid')
        } else {
            setStatus('Unpaid')
        }
    },[type])
    
    const defaultProps = {
        options: currencies,
        getOptionLabel: (option) => option.label
      };

    const clientsProps = {
        options: clients,
        getOptionLabel: (option) => option.name
      };
      
      
   const metalsProps = {
    options: metals,
    getOptionLabel: (option) => option.metalName?option.metalName :''
  };

    const handleDateChange = (date) => {
      setSelectedDate(date);
    };

const calculateTotal = (shipCharges) => {
    if(shipCharges === undefined) {
        shipCharges = 0;
    }
    const overallSum = rates /100 * subTotal + subTotal + parseFloat(shipCharges)
    setVat(rates /100 * subTotal)
    setTotal(overallSum)
}
  const handleRates =(e) => {
    setRates(e.target.value)
    setInvoiceData((prevState) => ({...prevState, tax: e.target.value}))
  }

    // console.log(invoiceData)
    // Change handler for dynamically added input field
    const handleChange =(index, e) => {
        const values = [...invoiceData.items]
        values[index][e.target.name] = e.target.value
        setInvoiceData({...invoiceData, items: values})
        calculateAmount(stockPrice);
        
    }

    const calculateAmount = (price) =>{

        const tmpitems = [...invoiceData.items];
        tmpitems.forEach((item)=>{

            if(stockPrice>0 && !isNaN(item.metal?.metalName)){
                //stock Price  X 1.01 / 31.1 X (purity) + labor becomes unit price                
                var purity = '0.'+item.metal?.metalName.trim();
                item.unitPrice = ((parseFloat(((price*1.01) / (31.1 * parseFloat(purity)))) + parseFloat(item.labor))).toFixed(2);
                item.amount = parseFloat(item.weight) * parseFloat(item.unitPrice).toFixed(2);
               }   

        });
        setInvoiceData({...invoiceData, items: tmpitems});  
        //console.log(JSON.stringify(invoiceData));      
    }

    useEffect(() => {
            //Get the subtotal
            const subTotal =()=> {
            var arr = document.getElementsByName("amount");
            var subtotal = 0;
            for(var i = 0; i < arr.length; i++) {
                if(arr[i].value) {
                    subtotal += +arr[i].value;
                }
                setSubTotal(subtotal)
            }
        }

        subTotal()
       
    }, [invoiceData])


    useEffect(() => {
        const total =() => {
            
            //Tax rate is calculated as (input / 100 ) * subtotal + subtotal 
            const overallSum = rates /100 * subTotal + subTotal + parseFloat(shippingCharges)
            //VAT is calculated as tax rates /100 * subtotal
            setVat(rates /100 * subTotal)
            setTotal(overallSum)


        }
        total()
    }, [invoiceData, rates, subTotal])
    

    const handleAddField = (e) => {
        e.preventDefault()
        setInvoiceData((prevState) => ({...prevState, items: [...prevState.items,  {metal:{id:0,metalName:''} ,description:'',labor:0, unitPrice: 0, weight: 0, amount: 0 }]}))
    }

    const handleRemoveField =(index) => {
        const values = invoiceData.items
        values.splice(index, 1)
        setInvoiceData((prevState) => ({...prevState, values}))
        // console.log(values)
    }
    

    //console.log(invoiceData)

    const handleSubmit =  async (e ) => {
        e.preventDefault()
        if (client==null){
            alert("select customer")
            return
        }

    
        const items = [...invoiceData.items]
        const saveItems=[];

        if (items.length===0){
            alert("enter item info")
            return
        }

        items.forEach((item)=>{
        
           saveItems.push({metalId:item.metal.id, 
            weight:parseFloat(item.weight),
            description: item.description,
            labor:parseFloat(item.labor),
            stockPrice: stockPrice,
            unitPrice:parseFloat(item.unitPrice),
            amount:parseFloat(item.amount) })     
        });

        let saveFormData = {};
        if (id===undefined)
           saveFormData= {
                invoiceNumber: invoiceNumber,
                invoiceDate: selectedDate, 
                createdBy:user?.result?.id,
                customerId:client.id,
                stockPrice:stockPrice,
                shippingMethod: shippingMethod,                
                shippingCharges: shippingCharges,
                taxRate: parseFloat(rates),
                status:'New',
                notes: notes,
                items: saveItems, 
            }
        else
            saveFormData= {
            id:id,
            invoiceNumber: invoiceNumber,
            invoiceDate: selectedDate, 
            modifiedBy:user?.result?.id,
            stockPrice:stockPrice,
            shippingMethod: shippingMethod,                
            shippingCharges: shippingCharges,
            taxRate: parseFloat(rates),
            customerId:client.id,
            status:'New',
            notes: notes,
            items: saveItems, 
            }

        if(invoice) {
         dispatch(updateInvoice(saveFormData,history,openSnackbar)) 
      
        } else {

        dispatch(createInvoice(saveFormData,history,openSnackbar))
       
        }

        // setInvoiceData(initialState)
    }

   
    const classes = useStyles()
    const [open, setOpen] = useState(false);

    const CustomPaper = (props) => {
        return <Paper elevation={3} {...props} />;
      };


      if(!user) {
        history.push('/login')
      }
    

    return (
    <div className={styles.invoiceLayout}>
        <form onSubmit={handleSubmit} className="mu-form">
            <AddClient setOpen={setOpen} open={open} />
            <Container  className={classes.headerContainer}>
                
                <Grid container justifyContent="space-between" >
                    <Grid item>
                        {/* <Avatar alt="Logo" variant='square' src="" className={classes.large} /> */}
                    </Grid>
                    <Grid item>
                        <InvoiceType type={type} setType={setType} />
                        Invoice #:
                        <div style={{
                            marginTop: '15px',
                            width: '100px',
                            padding: '8px',
                            display: 'inline-block',
                            backgroundColor: '#f4f4f4',
                            outline: '0px solid transparent'
                        }} 
                            contenteditable="false"
                            
                        >
                        <span style={{width:'40px',
                            color: 'black',
                            padding: '15px',
                        }} 
                            contenteditable="false"> {invoiceNumber}</span>
                        <br/>
                        </div>
                    </Grid>
                </Grid >
            </Container>
            <Divider />
            <Container>
                <Grid container justifyContent="space-between" style={{marginTop: '40px'}} >
                    <Grid item style={{width: '50%'}}>
                        <Container>
                            <Typography variant="overline" style={{color: 'gray', paddingRight: '3px'}} gutterBottom>Bill to</Typography>
                            

                            {client  && (
                                <>
                                    <Typography variant="subtitle2" gutterBottom>{client.name}</Typography>
                                    <Typography variant="body2" >{client.email}</Typography>
                                    <Typography variant="body2" >{client.phone}</Typography>
                                    <Typography variant="body2">{client.address}</Typography>
                                    <Button color="primary" size="small" style={{textTransform: 'none'}} onClick={()=> setClient(null)}>Change</Button>
                                </>
                            )}
                            <div style={client? {display: 'none'} :  {display: 'block'}}>
                                <Autocomplete
                                            {...clientsProps}
                                            PaperComponent={CustomPaper}
                                                renderInput={(params) => <TextField {...params}
                                                required={!invoice && true} 
                                                label="Select Customer" 
                                                margin="normal" 
                                                variant="outlined"
                                                />}
                                            value={clients?.name}
                                            onChange={(event, value) => setClient(value)}
                                            
                                    />

                            </div>
                            {!client && 
                                <>
                                <Grid item style={{paddingBottom: '10px'}}>
                                    <Chip
                                        avatar={<Avatar>+</Avatar>}
                                        label="New Customer"
                                        onClick={() => setOpen(true)}
                                        variant="outlined"
                                    />
                                </Grid>
                                </>
                            }
                        </Container>
                    </Grid>

                    <Grid item style={{marginRight: 20, textAlign: 'right'}}>
                         <Typography variant="overline" style={{color: 'gray'}} gutterBottom>Invoice Date</Typography>
                        <Typography variant="body2" gutterBottom>{moment(selectedDate).format("MMM Do YYYY")}</Typography>
                        <Typography variant="overline" gutterBottom>Stock Price</Typography>
                        <Typography variant="h6" gutterBottom align="right">{currency}  <TextField  inputProps={{min: 0, style: { textAlign: 'right',width:"70px" }}}  size="small"  type="number" name="stockPrice"  onChange={e => {setStockPrice(parseFloat(e.target.value)); calculateAmount(parseFloat(e.target.value));}} value={stockPrice} placeholder="0" /></Typography>
                    </Grid>
                </Grid>
            </Container>

        
    <div>

        <TableContainer component={Paper} className="tb-container">
        <Table className={classes.table} aria-label="simple table">
            <TableHead>
            <TableRow>
                <TableCell>Item</TableCell>
                <TableCell align="right">Weight</TableCell>
                <TableCell align="left">Desc</TableCell>                
                <TableCell align="right">Labor</TableCell>
                <TableCell align="right">Price</TableCell>
                <TableCell align="right">Amount</TableCell>
                <TableCell >Action</TableCell>
            </TableRow>
            </TableHead>
            <TableBody>
            {invoiceData.items.map((itemField, index) => (
                <TableRow key={index}>
                <TableCell  scope="row" style={{width: '20%' }}> 
                <Autocomplete
                                            {...metalsProps}
                                            PaperComponent={CustomPaper}
                                            style={{width: '90%'}}
                                            sx={{ ml: 1, flex: 1 }}
                                                renderInput={(params) => <TextField {...params}
                                                required={!invoice && true} 
                                                label="" 
                                                margin="normal" 
                                                variant="outlined"
                                                name="metalId"
                                                />}
                                            value={itemField.metal}
                                            onChange={(event, value) => {
                                                if(value!=null){
                                                const values = [...invoiceData.items]
                                                values[index]['metal'] = value;
                                                setInvoiceData({...invoiceData, items: values});
                                                calculateAmount();
                                                //alert(JSON.stringify(inventoryData))
                                                }
                                              
                                            }}
                                            
                                  />   
                </TableCell>
                <TableCell align="right"> <InputBase inputProps={{ style: { textAlign: 'right',width:"70px" }}} sx={{ ml: 1, flex: 1 }} type="number" name="weight" onChange={e => {handleChange(index, e);}} value={itemField.weight} placeholder="0" /> </TableCell>
                <TableCell alight="left"> <InputBase style={{textAlign:"left"}}  sx={{ ml: 1, flex: 1 }} multiline="true" type="text" name="description" onChange={e => handleChange(index, e)} value={itemField.description} placeholder="description" /> </TableCell>
                <TableCell align="right"> <InputBase inputProps={{min: 0, style: { textAlign: 'right',width:"70px" }}} sx={{ ml: 1, flex: 1 }} type="number" name="labor"  onChange={e => handleChange(index, e)} value={itemField.labor} placeholder="0" /> </TableCell>
                <TableCell align="right"> <InputBase inputProps={{ style: { textAlign: 'right',width:"70px" }}} sx={{ ml: 1, flex: 1 }} type="number" name="unitPrice"  value={itemField.unitPrice} placeholder="0" disabled/> </TableCell>
                <TableCell align="right"> <InputBase inputProps={{style: { textAlign: 'right',width:"70px" }}} sx={{ ml: 1, flex: 1 }} type="number" name="amount"   value={itemField.amount} disabled placeholder="0" /> </TableCell>
                <TableCell align="right"> 
                    <IconButton onClick={() =>handleRemoveField(index)}>
                        <DeleteOutlineRoundedIcon style={{width: '20px', height: '20px'}}/>
                    </IconButton>
                </TableCell>
                
                </TableRow>
            ))}
            </TableBody>
        </Table>
        </TableContainer>
            <div className={styles.addButton}>
                <button onClick={handleAddField}>+</button>
            </div>
    </div>
             <div style={{display: 'flex', gap: '20px'}}>
              <div style={{width:"50%"}}></div>
             <div style={{width:"50%"}}>
             <div className={styles.invoiceSummary} style={{width:"100%"}}> 
            
            <div className={styles.summary}>Invoice Summary</div>
            <div className={styles.summaryItem}>
                <p>Sub total:</p>
                <h4>{toCommas(subTotal.toFixed(2))}</h4>
            </div>
            <div className={styles.summaryItem} style={{display: 'none'}}>
                <p>VAT(%):</p>
                <h4>{toCommas(vat.toFixed(2))}</h4>
            </div>
            <div className={styles.summaryItem} >
                <p>Shipping Method:</p>
                <Select
                    value={shippingMethod}
                    onChange={(e) => {
                        setShippingMethod(e.target.value);
                        const selectedShipping = shippings.find(s => s.name === e.target.value);
                        if (selectedShipping) {
                            setShippingCharges(selectedShipping.charges);
                            calculateTotal(selectedShipping.charges);
                        }
                    }}
                    style={{marginLeft: '0px'}}
                    disableUnderline
                    displayEmpty
                    MenuProps={{
                        anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
                        transformOrigin: { vertical: 'top', horizontal: 'right' },
                        getContentAnchorEl: null,
                    }}
                >
                    <MenuItem value="" disabled s>
                        Select Shipping Method
                    </MenuItem>
                    {shippings.map((shipping) => (
                        <MenuItem key={shipping.id} value={shipping.name}>
                            {shipping.name} ({shipping.country})
                        </MenuItem>
                    ))}
                </Select>
            </div>
            <div className={styles.summaryItem}>
                <p>Shipping Charges:</p>
                <TextField
                    type="number"
                    step="0.01"
                    value={shippingCharges}
                    onChange={(e) => { setShippingCharges(e.target.value); calculateTotal(e.target.value); }}
                    inputProps={{min: '0'}}
                    style={{width: '40%'}}
                />
            </div>
            <div className={styles.summaryItem}>
                <p>Total</p>
                <h4 style={{color: "black", fontSize: "18px", lineHeight: "8px"}}>{currency} {toCommas(total.toFixed(2))}</h4>
            </div>
            
              </div>
              </div>
            </div>        
      
        
        <div className={styles.toolBar} style={{display: 'none'}}>
            <Container >
                <Grid container >
                    <Grid item style={{marginTop: '16px', marginRight: 10}}>
                        <TextField 
                            type="text" 
                            step="any" 
                            name="rates" 
                            id="rates" 
                            value={rates} 
                            onChange={handleRates} 
                            placeholder="e.g 10" 
                            label="Tax Rates(%)"
                            
                        />
                    </Grid>
                    
                    
                </Grid>
                
            </Container>
        </div>
            <div className={styles.note}>
                <h4>Notes</h4>
                <textarea 
                style={{border: 'solid 1px #d6d6d6', padding: '10px'}}
                    placeholder="Provide additional details or terms of service"
                    onChange={(e) => setNotes(e.target.value)}
                    value={notes}
                />
            </div>

            {/* <button className={styles.submitButton} type="submit">Save and continue</button> */}
            <Grid container justifyContent="center" spacing={2}>
                <Grid item>
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        className={classes.button}
                        startIcon={<SaveIcon />}
                        type="submit"
                    >
                        Save and Continue
                    </Button>
                </Grid>
                
               
            </Grid>
        </form>
    </div>
    )
}

export default Invoice
